import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const toolUserObserveDictionary = createSimpleDictionary([
    { id: 'exclude_irregular', name: 'bets.toolUserObserve.excludeIrregular' },
    { id: 'irregular', name: 'bets.toolUserObserve.irregular' },
    { id: 'watched', name: 'bets.toolUserObserve.watched' },
]);
